import Column from "@components/column";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import SurgeForm from "./form";
import SurgeList from "./list";
import BackButton from "@components/backButton";
import { useParams } from "react-router-dom";
import { Zone } from "@apis/index";

const Surge = () => {
  const { zoneId } = useParams();
  const [surges, setSurges] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [editingSurge, setEditingSurge] = useState<any>(null);

  const fetchSurges = useCallback(async () => {
    if (!zoneId) return;
    try {
      const response: any = await Zone.getSurgePrice({ id: zoneId });
      if (Array.isArray(response)) {
        setSurges(response);
      } else {
        setSurges([]);
      }
    } catch (error) {
      console.error("Error fetching surge prices:", error);
    } finally {
      setLoading(false);
    }
  }, [zoneId]);

  useEffect(() => {
    fetchSurges();
  }, [fetchSurges]);

  const hasActiveSurge = useMemo(
    () => surges.some((s) => s.status === true),
    [surges],
  );

  const handleEdit = (surge: any) => {
    setEditingSurge(surge);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleClearEdit = () => {
    setEditingSurge(null);
  };

  return (
    <Column stylecolumn="gap: 20px;">
      <BackButton path="/admin/zone-setup" />
      <SurgeForm
        onRefresh={fetchSurges}
        editingData={editingSurge}
        onClearEdit={handleClearEdit}
        hasActiveSurge={hasActiveSurge}
      />
      {!loading && (
        <SurgeList
          data={surges}
          onRefresh={fetchSurges}
          onEdit={handleEdit}
          hasActiveSurge={hasActiveSurge}
        />
      )}
    </Column>
  );
};

export default Surge;
